<template>
  <v-card elevation="0" rounded="0">
    <v-toolbar dark flat color="brandCyan" rounded="0" width="100%">
      <div>
        <v-toolbar-title>{{ editingPayment ? "Edit reward" : "Add a payment" }}</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="close">
          <span class="mt-1">Close</span>
          <v-icon class="ml-2">mdi-close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <!-- <v-row no-gutters justify="center" full-width no-wrap class="mb-2">
      <v-col cols="10" class="d-flex flex-column text-left mx-0 my-0">
        <p class="mb-0 mt-10 mediumGrey--text">
          Rewards
        </p>
      </v-col>
    </v-row> -->
    <div class="mt-6 mx-12 text-left">
      <div>
        <div class="d-flex justify-space-between mediumGrey--text" style="padding-right: 40px">
          <span>Select a budget to fund this payment</span>
          <span v-if="budgetId">Balance</span>
        </div>
        <v-select
          label="Budget"
          outlined
          dense
          attach
          :menu-props="{ bottom: true, offsetY: true }"
          class="mt-2"
          :items="visibleItems"
          v-model="budgetId"
          item-value="budgetId"
          item-text="displayNameWithBalance"
          no-data-text="
           No budgets found
           
          "
          :rules="[(v) => !!v || 'Budget is required']"
          :loading="loadingBudgets || loading.budgets"
        >
          <template v-slot:item="{ item }">
            <div class="d-flex align-center justify-space-between full-width">
              <span class="budget-name-container text-overflow-clip">
                {{ item.budgetDisplayName }}
              </span>
              <span
                ><span v-if="item.awardId == 1">$ </span>{{ formatCurrency(item.budgetBalance) }}
                <span v-if="item.awardId != 1 && item.Award">{{
                  item.budgetBalance == 1 && item.Award.unitSingular
                    ? item.Award.unitSingular
                    : item.budgetBalance != 1 && item.Award.unitPlural
                    ? item.Award.unitPlural
                    : ""
                }}</span></span
              >
            </div>
          </template>
          <template v-slot:selection="{ item }">
            <div class="d-flex align-center justify-space-between full-width">
              <span class="budget-name-container text-overflow-clip">
                {{ item.budgetDisplayName }}
              </span>
              <span
                ><span v-if="item.awardId == 1">$ </span>{{ formatCurrency(item.budgetBalance) }}
                <span v-if="item.awardId != 1 && item.Award">{{
                  item.budgetBalance == 1 && item.Award.unitSingular
                    ? item.Award.unitSingular
                    : item.budgetBalance != 1 && item.Award.unitPlural
                    ? item.Award.unitPlural
                    : ""
                }}</span></span
              >
            </div>
          </template>
        </v-select>
        <p>
          Note: All rewards in a program use the same budget. Changing this will impact any other
          rewards.
        </p>
        <p
          class="primary--text text-right cursor-pointer"
          v-if="budgetId && selectedBudget"
          @click="dialog.fundingWidget = true"
        >
          <v-icon small color="primary">mdi-plus</v-icon>Add funds to your program budget
        </p>
        <v-textarea
          outlined
          dense
          label="Rule summary / description (optional)"
          :rules="formRules.stringOptional(512)"
          v-model="description"
        >
        </v-textarea>
        <div class="d-flex align-start mt-7">
          <p class="mt-2">Send</p>
          <v-text-field
            v-model="amount"
            outlined
            dense
            style="width: 60px"
            type="number"
            class="mx-3"
            placeholder="0"
            min="0"
            step="1"
            :rules="paymentAmountRules"
            @wheel="$event.target.blur()"
          >
            <template v-slot:prepend-inner>
              <div style="margin-top: 4px" v-if="selectedBudget && selectedBudget.awardId == 1">
                $
              </div>
            </template>
            <template v-slot:append>
              <div
                style="margin-top: 4px"
                v-if="selectedBudget && selectedBudget.awardId != 1 && selectedBudget.Award"
              >
                {{
                  amount && amount == 1 && selectedBudget.Award.unitSingular
                    ? selectedBudget.Award.unitSingular
                    : selectedBudget && amount != 1 && selectedBudget.Award.unitPlural
                    ? selectedBudget.Award.unitPlural
                    : ""
                }}
              </div>
            </template></v-text-field
          >
          <p class="mt-2">to each participant's wallet.</p>
        </div>

        <v-textarea
          label="Optional payment memo"
          outlined
          v-model="memo"
          :rules="[(v) => !v || !!(v && v.length < 240) || 'Your note should be shorter']"
        ></v-textarea>
        <!-- <pre style="font-size: 12px;">{{ JSON.stringify(rules, null, 2) }}</pre> -->
        <vueJsonEditor
          v-if="permissions?.includes('programs:create:payoutrule')"
          v-model="rules"
          :show-btns="false"
          :mode="'code'"
          :expandedOnStart="true"
        ></vueJsonEditor>

        <v-btn
          class="my-3"
          color="primary"
          :disabled="!validateForm"
          :outlined="!validateForm"
          @click="addRewardToProgramV2"
          >{{ editingPayment ? "Update reward" : "Add to program" }}</v-btn
        >
      </div>
    </div>

    <!-- Budget funding drawer -->
    <v-navigation-drawer
      v-model="dialog.fundingWidget"
      temporary
      fixed
      right
      width="500"
      disable-route-watcher
    >
      <StripePaymentMethodsManager
        v-if="dialog.fundingWidget"
        @reset="dialog.fundingWidget = false"
        @get-budgets="getBudgets"
        :destinationBudget="selectedBudget"
        :budgets="budgets"
        :clientId="clientId"
        source="PROGRAM_WIZARD"
      />
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import BudgetService from "@/services/BudgetService";

import StripePaymentMethodsManager from "@/components/stripe/StripePaymentMethodsManager.vue";

import vueJsonEditor from "vue-json-editor";

import { truncateNumber, numberWithCommas } from "@/shared_data/functions";
import { formRules } from "@/shared_data/data";

import { mapState } from "vuex";

export default {
  name: "ProgramClaimRewardWidget",
  components: {
    StripePaymentMethodsManager,
    vueJsonEditor,
  },
  props: {
    clientId: Number,
    budgets: Array,
    loadingBudgets: Boolean,
    existingReward: Object,
    editingPayment: Boolean,
    preloadBudgetId: Number,
  },
  data() {
    return {
      formRules,
      rewardType: "Payment",
      data: {
        budgets: [],
        search: null,
      },
      dialog: {
        fundingWidget: false,
        search: false,
      },
      loading: {
        budgets: false,
      },

      // Data used for payment form
      description: null,
      budgetId: null,
      amount: null,
      memo: null,
      rules: {
        conditions: {
          and: [
            {
              field: "example",
              value: "example-value",
              source: "claim_dependency",
              operator: "equals",
            },
          ],
        },
      },

      rewardToAdd: null,
    };
  },

  created() {
    // We pass in props and fetch budgets or badges if not passed in
    if (!this.budgets) this.getBudgets();

    if (this.editingPayment || this.existingReward) {
      console.log(this.existingReward);
      if (this.editingPayment) {
        // Alread selected a badge, so preload payment
        this.rewardType = "Payment";
      }
      this.budgetId = this.existingReward.budgetId;
      this.amount = this.existingReward.amount;
      this.memo = this.existingReward.memo;
      this.description = this.existingReward.description;
      this.rules = this.existingReward.rules;
    } else if (this.preloadBudgetId) {
      this.budgetId = this.preloadBudgetId;
    }
  },
  mounted() {},
  methods: {
    truncateNum(amount, precision) {
      return truncateNumber(amount, precision);
    },
    formatCurrency(amount) {
      return numberWithCommas(amount);
    },
    getBudgets() {
      if (this.budgets) {
        this.$emit("get-budgets");
        return;
      }
      this.loading.budgets = true;
      BudgetService.getBudgets()
        .then((response) => {
          var budgets = response
            .filter(
              (budget) =>
                budget.status !== "Deleted" &&
                budget.status !== "Expired" &&
                budget.clientId == this.clientId
            )
            .map((x) => {
              var obj = x;
              obj.id = x.budgetId.toString();
              obj.context = "Budgets";
              obj.contextResourceId = x.budgetId.toString();
              obj.contextColumn = "metricValue";

              return obj;
            });
          console.log("Budgets: ", budgets);
          this.data.budgets = budgets;
          this.loading.budgets = false;
        })
        .catch((error) => {
          console.log("Error getting budgets ", error);
          this.loading.budgets = false;
        });
    },
    close() {
      this.$emit("close");
    },
    addRewardToProgramV2() {
      console.log("add reward to program");

      this.rewardToAdd = {
        id: this.existingReward?.id || new Date().toString(),
        programPayoutRuleId: this.existingReward?.programPayoutRuleId || null,
        context: "reward",
        amount: this.amount,
        budgetId: this.budgetId,
        type: this.existingReward?.type || "PAY_PER",
        icon: "mdi-trophy-variant-outline",
        iconColor: "brand-dark-green",
        displayGrabber: false,
        description: this.description,
        memo: this.memo && this.memo.trim() != "" ? this.memo : null,
        rules: this.rules,
      };

      console.log("reward to add", this.rewardToAdd);
      this.$emit("add-to-program", this.rewardToAdd);
      this.rewardToAdd = null;
    },
  },
  computed: {
    ...mapState(["permissions"]),
    visibleItems() {
      if (this.budgets) return this.budgets;
      else return this.data.budgets;
    },
    selectedBudget() {
      if (!this.budgetId) return null;
      if (this.budgets) var budgets = this.budgets;
      else budgets = this.data.budgets;
      let budget = budgets.find((x) => x.budgetId == this.budgetId);
      if (budget) return budget;
      return null;
    },
    paymentAmountRules() {
      var rules = [(v) => !!(v && parseFloat(v) > 0) || "Payment amount must be greater than 0"];
      // if (this.slideDetails.paymentType !== "NON_CASH") {
      rules.push(
        (v) =>
          !!(
            v &&
            (!v.toString().includes(".") ||
              (v.toString().includes(".") &&
                v.toString().substring(v.toString().indexOf(".") + 1).length < 3))
          ) || `Payment amount shouldn't be longer than 2 decimals.`
      );
      // } else {
      //   rules.push(
      //     (v) =>
      //       !!(v && !v.toString().includes(".")) ||
      //       `Payment amount shouldn't contain a decimal.`
      //   );
      // }
      return rules;
    },
    totalBeingSpent() {
      if (!this.amount) return 0;
      if (!this.numParticipants) var numPeople = 0;
      else numPeople = this.numParticipants;

      return truncateNumber((this.amount * numPeople).toFixed(3), 2);
    },
    budgetBalanceAfterPayment() {
      if (!this.selectedBudget) return 0;
      return truncateNumber(
        (this.selectedBudget.budgetBalance - this.totalBeingSpent).toFixed(3),
        2
      );
    },
    validateForm() {
      return (
        this.budgetId &&
        this.visibleItems.find((x) => x.budgetId == this.budgetId) &&
        this.amount &&
        parseFloat(this.amount) > 0 &&
        (!this.amount.toString().includes(".") ||
          (this.amount.toString().includes(".") &&
            this.amount.toString().substring(this.amount.toString().indexOf(".") + 1).length < 3))
      );
    },
  },
  watch: {
    "dialog.fundingWidget": function (newVal) {
      if (newVal === false) {
        // side drawer just closed so we refresh budgets in case they have funded
        this.getBudgets();
      }
    },
  },
};
</script>

<style scoped>
/* Used for the tab buttons at the top */
.tab-group-container {
  padding: 5px 5px;
  border-radius: 7px;
  width: 230px;
  background-color: var(--v-lightGrey-base);
}
.tab-button {
  width: 100px;
  text-align: center;
  text-transform: none !important;
  letter-spacing: 0em;
}
.active-tab-button {
  background-color: white;
  background: white;
  border: 1px solid;
  border-color: var(--v-grey-base);
}

/* Used to clip the learning module name */
.text-overflow-clip {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/* Used to give gray background to learning cards in previews */
.learning-card-row {
  border-radius: 5px;
  background: var(--v-lightGrey-base);
  width: 100%;
  height: 35px;
  padding-top: 6px;
  padding-left: 12px;
}

/* Used for the small plus button after expanding a module to add it to the program */
.add-module-button {
  border-radius: 100%;
  width: 25px;
  height: 25px;
  background: var(--v-brand-base);
}

/* Class for the boxes around each item */
.element-box {
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid lightgray;
  border-radius: 5px;
  /* height: 35px; */
  padding-top: 7px;
}

/* Used to cap budget names and add ellipsis at the end if too long */
.budget-name-container {
  width: calc(100% - 120px);
}
</style>
<style>
.jsoneditor-vue {
  height: 450px;
}
</style>
